import React from 'react'
import PropTypes from 'prop-types'
import { Platform, View, TouchableOpacity, Text, StyleSheet, GestureResponderEvent } from 'react-native'

type SwatchProps = {
  keyID: number,
  /** The label of the product option to display on the button. */
  label: string,
  /** Sets the color of the button. */
  selected: boolean,
  /** The active color of the button */
  accentColor: string,
  /** A callback function for when the swatch is clicked. */
  onSwatchClick: Function,
}

/**
 * A product option button. Displays near the end of the configurator.
 * @component
 */
export class Swatch extends React.Component<SwatchProps> {
  static propTypes = {
    keyID: PropTypes.number,
    label: PropTypes.string,
    selected: PropTypes.bool,
    accentColor: PropTypes.string,
    onSwatchClick: PropTypes.func,
  }

  static defaultProps = {
    label: 'Button',
    selected: true,
    accentColor: 'dodgerblue',
    onSwatchClick: () => {console.log('onSwatchClick unimplemented')},
  }
  
  onClick(event: GestureResponderEvent) {
    this.props.onSwatchClick(this.props.keyID)
  }

  render() {
    return (
      <TouchableOpacity
        onPress={this.onClick.bind(this)}
        style={{
          width: Platform.OS === 'web' ? 'fit-content' : 'auto',
          borderWidth: 1, margin: 10, padding: 10, borderRadius: 20, borderColor: this.props.accentColor ?? 'dodgerblue', backgroundColor: this.props.selected ? this.props.accentColor ?? 'dodgerblue' : 'white'}}
      >
        <Text style={{fontWeight: '600', color: this.props.selected ? 'white' : this.props.accentColor ?? 'dodgerblue'}}>
          {this.props.label}
        </Text>
      </TouchableOpacity>
    )
  }
}

